import { Anchor, Button, Tooltip } from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useMemo } from "react";

const AnswerDirectLink = ({ link, isLinkedin }) => {
  const lang = useLanguage((s) => s.language);
  const keys = useMemo(() => {
    const regexEmail = /\/workflow\/([^\\/]+)\/([^\\/]+)\/reply/;
    const regexLinkedin = /\/workflow\/([^\\/]+)\/reply/;
    const match = link.match(isLinkedin ? regexLinkedin : regexEmail);

    const prm_contact_id = match[1];
    const reply_id = match[2];

    return { prm_contact_id, reply_id };
  }, [isLinkedin, link]);

  return (
    <Tooltip
      label={
        isLinkedin
          ? lang.statistics.columns.sender.view_conversation
          : lang.statistics.columns.sender.view
      }
    >
      <Anchor
        target="_blank"
        href={`/reply?p_id=${keys.prm_contact_id}${
          keys?.reply_id ? `&r_id=${keys.reply_id}` : ""
        }&linkedin=${link.includes("linkedin") ? "true" : ""}`}
        mx={8}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Button variant="light" size={isLinkedin ? "sm" : "compact-sm"}>
          <IconExternalLink size={18} />
        </Button>
      </Anchor>
    </Tooltip>
  );
};

export default AnswerDirectLink;
